import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src3119819440/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .au registrations:</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <div style={{
        "width": "30em",
        "cssFloat": "right"
      }}>
    <img style={{
          "width": "100%"
        }} src="/cms-assets/images/tld/AUDA-Accredited_Registrar_Logo_FullColour.png" />
  </div>
  This document sets out the terms and conditions of your application for a Domain
  Name, and if successful, your Domain Name Licence. It records the agreement between
  you, the applicant or holder of a Domain Name Licence, and us, the registrar, in
  relation to the Domain Name.
    </p>
    <p>
  Australian Domain Name Administrator (auDA) has announced that from April 12,
  2021, new rules for com.au, net.au, org.au, and asn.au namespaces in the .au
  domain will come into effect.{' '}
  <a href="https://www.auda.org.au/news/new-rules-au-domain-names-launch-12-april-2021">
    Please refer to auda.org.au for more details
  </a>
  .
    </p>
    <p>
  <strong>Summary of Terms and Conditions</strong>
    </p>
    <blockquote>
  <p>(a) Registration and transfer orders may be submitted from 1 to 5 years</p>
  <p>
    (b) Domain names may be renewed up to 90 days before the expiry date and up
    to 30 days after the expiry date
  </p>
  <p>
    (c) If your application for a domain name is accepted and approved, you will
    be granted Domain Name Licence for that domain name
  </p>
  <p>
    (d) You are required to make several statements to us in relation to your
    domain name application – please read them carefully to ensure that those
    statements are correct
  </p>
  <p>
    (e) You are entitled to transfer your domain name registration to another
    registrar, and we will facilitate such transfer for you according to our
    obligations under auDA's Published Policies (see www.auda.org.au)
  </p>
  <p>
    (f) You are bound by the .au Dispute Resolution Policy (auDRP) in relation
    to your registered domain name, as well as such other dispute resolution
    policy which may be adopted by auDA from time to time
  </p>
  <p>
    (g) You accept that our liability and auDA's liability to you under these
    terms and conditions are limited
  </p>
    </blockquote>
    <p>
  <strong>1. DEFINITIONS.</strong>
    </p>
    <p>In this document, unless the context requires otherwise:</p>
    <p>
  <strong>auDA</strong> means .au Domain Administration Limited ACN 079 009 340,
  the .au domain names administrator.
    </p>
    <p>
  <strong>Domain Name</strong> means the domain name which is the subject of
  your application, and if successful, the Domain Name Licence.
    </p>
    <p>
  <strong>Domain Name Licence</strong> means your licence to use the Domain Name
  which is the subject of your application.
    </p>
    <p>
  <strong>Published Policies</strong> means those specifications and policies
  established and published by auDA from time to time at.
    </p>
    <p>
  <strong>Registry Operator</strong> means the operator of the domain names
  registry for the Domain Name.
    </p>
    <p>
  <strong>We</strong>, <strong>our</strong> or <strong>us</strong> refer to
  NameScout Corp. the registrar of record for your Domain Name Licence.
    </p>
    <p>
  <strong>You</strong> or <strong>your</strong> refer to the person applying
  for, or the holder of, a Domain Name Licence.
    </p>
    <p>
  <strong>2. GENERAL</strong>
    </p>
    <p>
  You are bound by the terms of this document, even if you have entered into
  this document through an agent, and even if you licence the use of the Domain
  Name to another person.
    </p>
    <p>
  <strong>3. DOMAIN NAMES APPLICATION AND REGISTRATION</strong>
    </p>
    <blockquote>
  <p>
    3.1 Your application for a Domain Name must be in the form prescribed under
    the Published Policies. The Domain Name must comply with the Published
    Policies.
  </p>
  <p>
    3.2 You accept that even if we have accepted and approved your Domain Name
    application, the application may still be rejected by the Registry Operator
    in performing its final integrity checks.
  </p>
  <p>
    3.3 You accept that neither you, nor we, have any proprietary right arising
    from the registered Domain Name, or the entry of a Domain Name in the domain
    names registry.
  </p>
  <p>
    3.4 All personal information pertaining to you are held by auDA for the
    benefit of the Australian public.
  </p>
    </blockquote>
    <p>
  <strong>4. DOMAIN NAME LICENCE</strong>
    </p>
    <blockquote>
  <p>
    4.1 Your Domain Name Licence will be effective for a 1 to 5 year period,
    once:
  </p>
  <blockquote>
    <p>
      (a) your application is accepted and approved by us and by the Registry
      Operator, and
    </p>
    <p>(b) you have paid the applicable fees,</p>
  </blockquote>
  <p>
    unless it is cancelled earlier under the terms of this document or under any
    Published Policies.
  </p>
  <p>
    4.2 Your Domain Name Licence may be renewed at the end of the term, as long
    as you:
  </p>
  <blockquote>
    <p>(a) pay the applicable renewal fees, and</p>
    <p>
      (b) continue to meet the eligibility criteria prescribed in the Published
      Policies.
    </p>
  </blockquote>
  <p>
    4.3 You accept that it is your responsibility to ensure that your Domain
    Name Licence is renewed.
  </p>
  <p>
    4.4 You may cancel your Domain Name Licence at any time by notifying us in
    writing.
  </p>
  <p>
    4.5 We may cancel your Domain Name Licence if you breach any provision of
    this document.
  </p>
    </blockquote>
    <p>
  <strong>5. YOUR STATEMENT TO US</strong>
    </p>
    <blockquote>
  <p>5.1 You confirm and state to us and to auDA separately that:</p>
  <blockquote>
    <p>
      (a) all the information set out in your Domain Name application, and all
      information you give us, are true, complete and correct, and are not
      misleading or deceptive, and your application is made in good faith, and
    </p>
    <p>
      (b) you meet, and continue to meet, for the duration of the Domain Name
      Licence, the eligibility criteria prescribed in the Published Policies for
      registering the Domain Name, and
    </p>
    <p>
      (c) you have not previously submitted an application for registration with
      another registrar, a domain name which is the same as the Domain Name, in
      circumstances where:
    </p>
    <p>
      (i) you are relying upon the same eligibility criteria for both domain
      names, and
    </p>
    <p>
      (ii) the Domain Name has previously been rejected by the other registrar,
      and
    </p>
    <p>
      (d) your registration or use of the Domain Name does not infringe any
      person's legal rights, and
    </p>
    <p>
      (e) you are aware that even if the Domain Name is accepted for
      registration, your entitlement to register the Domain Name may still be
      challenged by others who claim to have an entitlement to the Domain Name.
    </p>
  </blockquote>
  <p>
    5.2 You accept that if any of the above statements is found to be untrue,
    incomplete, incorrect or misleading, then either we or auDA may cancel your
    Domain Name Licence.
  </p>
  <p>
    5.3 You agree to indemnify us and auDA separately for any loss or damage
    suffered by us or auDA as a result of any of us relying upon your above
    statements.
  </p>
    </blockquote>
    <p>
  <strong>6. OUR OBLIGATIONS TO YOU</strong>
    </p>
    <blockquote>
  <p>
    6.1 Once your Domain Name application is accepted and approved, we will
    cause your Domain Name details to be entered in the domain names registry.
  </p>
  <p>6.2 We will give you immediate notice if:</p>
  <blockquote>
    <p>(a) we are no longer an accredited registrar, or</p>
    <p>(b) our auDA Accreditation is suspended or terminated, or</p>
    <p>(c) our registrar agreement with auDA is terminated by auDA.</p>
  </blockquote>
  <p>6.3 auDA may post notice of:</p>
  <blockquote>
    <p>(a) the fact that we are no longer an accredited registrar, or</p>
    <p>(b) the suspension or termination of our auDA Accreditation, or</p>
    <p>
      (c) the termination of our registrar agreement with auDA, on its web site,
      and may, if it considers appropriate, give such notice to you directly.
    </p>
  </blockquote>
    </blockquote>
    <p>
  <strong>7. YOUR OBLIGATIONS TO US</strong>
    </p>
    <blockquote>
  <p>
    7.1 You must comply with the Published Policies, as if they were
    incorporated into, and form part of, this document. In the event of any
    inconsistency between any Published Policy and this document, then the
    Published Policy will prevail to the extent of such inconsistency.
  </p>
  <p>7.2 You acknowledge that under the Published Policy:</p>
  <blockquote>
    <p>
      (a) there are mandatory terms and conditions that apply to all domain
      names licences, and such terms and conditions are incorporated into, and
      form part of, this document, and
    </p>
    <p>
      (b) you are bound by, and must submit to, the .au Dispute Resolution
      Policy (auDRP), and
    </p>
    <p>(c) auDA may delete or cancel the registration of a .au domain name.</p>
  </blockquote>
  <p>
    7.3 Throughout the period of your Domain Name Licence, you must give notice
    to the Registry Operator (through us) of any change to any information which
    you have given us.
  </p>
    </blockquote>
    <p>
  <strong>8. USE OF YOUR INFORMATION</strong>
    </p>
    <p>You give to:</p>
    <blockquote>
  <p>
    8.1 auDA, the right to publicly disclose to third parties, all information
    relation to the registered Domain Name in accordance with the Published
    Policies;
  </p>
  <p>
    8.2 us, the right to disclose to the Registry Operator, all information
    which are reasonably required by the Registry Operator in order to register
    the Domain Name in the domain names registry;
  </p>
  <p>
    8.3 the Registry Operator, the right to publicly disclose to third parties,
    all information relation to the registered Domain Name to enable the
    Registry Operator to maintain a public WHOIS service, provided that such
    disclosure is consistent with the National Privacy Principles, and the
    Published Policies.
  </p>
    </blockquote>
    <p>
  <strong>9. DISPUTE RESOLUTION</strong>
    </p>
    <blockquote>
  <p>
    9.1 auDA has in place a dispute resolution called the auDRP (which stands
    for .au Dispute Resolution Policy), which applies in the event of a dispute
    between a registrar and a domain name licence holder, or between a domain
    name licence holder and a third party, in relation to entitlements to domain
    names.
  </p>
  <p>
    9.2 The auDRP binds you and us severally as if it were incorporated in this
    document.
  </p>
  <p>9.3 You accept that:</p>
  <blockquote>
    <p>
      (a) auDA may develop and implement other dispute resolution policies which
      are accessible by you as an alternative and further to any complaints
      handling procedure adopted by us, and
    </p>
    <p>
      (b) such policies bind you and us severally as if they were incorporated
      in this document.
    </p>
  </blockquote>
    </blockquote>
    <p>
  <strong>10. TRANSFER OF REGISTRARS</strong>
    </p>
    <blockquote>
  <p>
    10.1 We will ensure that you can easily transfer your Domain Name
    registration to another registrar in accordance with the Published Policies.
    The Published Policies will address such matters as:
  </p>
  <blockquote>
    <p>(a) the maximum fees which we can charge you for such transfer,</p>
    <p>(b) when we are not allowed to charge you fees,</p>
    <p>
      (c) the conditions under which we must transfer the registered Domain
      Name, and
    </p>
    <p>
      (d) the conditions under which we are entitled not to transfer the
      registered the Domain Name.
    </p>
  </blockquote>
  <p>10.2 If:</p>
  <blockquote>
    <p>(a) we are no longer an accredited registrar, or</p>
    <p>(b) our auDA Accreditation is suspended or terminated, or</p>
    <p>(c) our registrar agreement with auDA is terminated by auDA,</p>
  </blockquote>
  <p>
    then we will transfer the registered Domain Name to a new registrar in
    accordance with the Published Policies within 30 days of a written notice
    being provided to you by auDA.
  </p>
  <p>
    10.3 If our registrar agreement with auDA is terminated, we will not charge
    you any fee for the transfer of the registered Domain Name to another
    registrar.
  </p>
    </blockquote>
    <p>
  <strong>11. LIMITATION OF LIABILITIES</strong>
    </p>
    <blockquote>
  <p>
    11.1 You must not pursue any claim against auDA or against us, and to the
    fullest extent permitted by law, neither auDA nor we are liable to you for
    any direct, indirect, special, punitive, exemplary or consequential losses
    or damages of any kind, including but not limited to losses or damages
    resulting from loss of use, lost profits, loss or corruption of data,
    business interruption, lost business revenue or third parties damages,
    arising from, as a result of, or otherwise in connection with, any act or
    omission whatsoever of auDA or us, or any of auDA's or our employees, agents
    or contractors, including but not limited to any breach by us of our
    obligations under this document, or under our registrar agreement with auDA.
  </p>
  <p>
    11.2 You agree to indemnity, keep indemnified and hold auDA and us, and
    auDA's and our employees, agents and contractors harmless from all and any
    claims or liabilities, arising from, as a result of, or otherwise in
    connection with, your registration or use of the Domain Name.
  </p>
  <p>
    11.3 You accept and agree that if we have any outstanding fees owing to
    auDA, which gives auDA a right to terminate our registrar agreement with
    auDA, then auDA may in its sole discretion terminate the registrar
    agreement.
  </p>
  <p>
    11.4 You accept and agree that neither auDA nor we are responsible for the
    use of any Domain Name in the domain names registry, and that auDA is not
    responsible for any conflict or dispute with any actual or threatened claim
    against a registrar or a domain name licence holder, including one relating
    to registered or unregistered trademark, a corporate, business or other
    trade-name, rights relating to a name or other identifying indicium or of an
    individual or other intellectual property rights of a third party or
    relating to the defamation or unlawful discrimination with respect to any
    other person.
  </p>
  <p>
    11.5 Despite any other provision of this document, and to the fullest extent
    permitted by law, neither auDA nor we are liable to you for consequential,
    indirect or special losses or damages of any kind (including without
    limitation, loss of profit, loss or corruption of data, business
    interruption or indirect loss) suffered by you as a result of any act or
    omission whatsoever of auDA or us, and our respective employees, agents, or
    sub-contractors.
  </p>
  <p>
    11.6 Nothing in this document is to be read as excluding, restricting or
    modifying the operation of Trade Practices Act 1974, or the application of
    any legislation which by law cannot be excluded, restricted or modified.
  </p>
    </blockquote>
    <p>
  <strong>12. OUR AGENCY</strong>
    </p>
    <p>
  We enter into this document as agent for auDA for the sole purpose, but only
  to the extent necessary, to enable auDA to receive the benefit of the rights
  and covenants conferred to it under this document. auDA is an intended third
  party beneficiary of this document.
    </p>
    <p>
  <strong>13. GENERAL</strong>
    </p>
    <blockquote>
  <p>13.1 In this document:</p>
  <blockquote>
    <p>
      (a) a reference to this or other document includes the document as varied
      or replaced regardless of any change in the identity of the parties;
    </p>
    <p>
      (b) a reference to writing includes all modes of representing or
      reproducing words in a legible, permanent and visible form;
    </p>
    <p>
      (c) headings and sub-headings are inserted for ease of reference only and
      do not affect the interpretation of this document; and
    </p>
    <p>
      (d) where an expression is defined, another part of speech or grammatical
      form of that expression has a corresponding meaning.
    </p>
  </blockquote>
  <p>
    13.2 All previous agreements, statements, explanations and commitments,
    expressed or implied, affecting the subject matter of this document are
    superseded by this document and have no effect
  </p>
  <p>
    13.3 If a provision in this document is held to be illegal, invalid, void,
    voidable or unenforceable, that provision must be read down to the extent
    necessary, or severed if necessary, to ensure that it is not illegal,
    invalid, void, voidable or unenforceable.
  </p>
  <p>
    13.4 This document is governed by and is to be construed in accordance with
    the laws of Victoria, Australia. Each party irrevocably and unconditionally
    submits to the non-exclusive jurisdiction of the courts of Victoria,
    Australia and waives any right to object to proceedings being brought in
    those courts.
  </p>
    </blockquote>
    <p>
  The above terms and conditions contained in this Schedule D - Registry
  Operator Terms and Conditions Applicable to all .AU Registrations are ©
  Maddocks, and .au Domain Administration Limited 2008. Used with permission.
    </p>
    <p>
  <strong>14. REFUND POLICY</strong>
    </p>
    <p>
  Applications for .au domains that have been rejected are eligible for refund.
  Please email your refund request to service@namescout.com. Namescout Corp will
  verify that you are eligible for refund, and will, by return email confirm the
  status of your refund request. Namescout Corp will make every effort to
  process your refund within 30 days of receiving the request.
    </p>
    <p>
  <strong>15. COMPLAINTS HANDLING POLICY</strong>
    </p>
    <p>
  Namescout Corp is committed to providing quality Customer Service and we aim
  to resolve any Registrant complaints or disputes quickly, fairly and
  efficiently. Namescout Corp also respects your right to complain, which is
  also outlined in the .au Domain Name Suppliers' Code of Practice. To read the
  Code, please refer to the web site located at http://www.auda.org.au. To
  notify Namescout Corp of your complaint or dispute, please send an email to
  service@namescout.com. Namescout Corp typically responds to all inquiries
  submitted by email within 24 hours of its receipt, during our regular hours of
  operation. We will make every effort to provide a response to your complaint
  or dispute within 30 days.
    </p>
    <p>
  <strong>16. WHOIS policy</strong>
    </p>
    <p>
  For information about auDA's WHOIS policy please visit:{' '}
  <a href="http://www.auda.org.au/whois">www.auda.org.au/whois</a>
    </p>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      